import {ZendeskCategory} from 'zendesk';

export class ProductSubnav {
  private readonly sections: Map<string, HTMLElement> = new Map();
  private readonly tabs: Map<string, HTMLAnchorElement> = new Map();
  private readonly zendesk?: ZendeskCategory;

  public static init(): ProductSubnav | void {
    const nav = document.querySelector(".product-subnav") as HTMLElement;
    if (nav) return new ProductSubnav(nav);
  }

  constructor(private readonly nav: HTMLElement) {
    for (const section of document.getElementsByClassName("product-subsection")) {
      this.sections.set(section.id, section as HTMLElement);
      if (section.id === 'support') this.zendesk = new ZendeskCategory(section as HTMLElement);
    }
    this.nav
      .querySelectorAll<HTMLAnchorElement>("a.subnav-item")
      .forEach((tab) => {
        this.tabs.set(tab.hash.replace(/^#\//, ""), tab);
      });
    window.addEventListener("hashchange", () => this.update());
    this.update();
  }

  private update(): void {
    const id = window.location.hash.replace(/^#?\//, "");
    if (!this.sections.has(id)) return;
    if (id === 'support') this.zendesk.load();
    document.body.setAttribute("data-tabs", id);
    this.sections.forEach((section) => {
      section.classList.toggle("active", section.id === id);
    });
    this.tabs.forEach((tab, tabId) => {
      tab.classList.toggle("active", tabId === id);
    });
  }
}

export class ProductReview {
  public static init(): ProductReview | void {
    const reviewWrapper = document.querySelector(
      ".product-subsection__review"
    ) as HTMLElement;
    if (reviewWrapper) return new ProductReview(reviewWrapper);
  }
  constructor(private readonly reviewWrapper: HTMLElement) {
    this.moveSupportElement();
    this.addFormReviewText();
    this.setTotalReviews();
  }
  moveSupportElement() {
    const headerReviewWidget = this.reviewWrapper.querySelector(
      ".jdgm-rev-widg__header"
    );
    if (!headerReviewWidget) return;
    headerReviewWidget.appendChild(
      this.reviewWrapper
        .querySelector<HTMLTemplateElement>("template#support")
        .content.firstElementChild.cloneNode(true)
    );
  }
  addFormReviewText() {
    const headerReviewWidget = this.reviewWrapper.querySelector(
      ".jdgm-rev-widg__header"
    );

    if (!headerReviewWidget) return;
    headerReviewWidget.appendChild(
      this.reviewWrapper
        .querySelector<HTMLTemplateElement>("template#form")
        .content.firstElementChild.cloneNode(true)
    );
  }
  setTotalReviews() {
    const reviewWidget = this.reviewWrapper.querySelector(".jdgm-rev-widg");
    const totalText = this.reviewWrapper.querySelector(
      ".product-subsection__review-count"
    ) as HTMLParagraphElement;
    if (!reviewWidget) return;
    const reviewTotal: string = reviewWidget.getAttribute(
      "data-number-of-reviews"
    );
    totalText.innerText = `${reviewTotal} Ratings`;
  }
}
